import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { WidgetPagesEntity, OldWidgetsEntity } from './widget-pages.models'

@Injectable({
  providedIn: 'root',
})
export class WidgetPagesApiService extends GbApiService {
  getOldWidgetPages(auctionUrl: string) {
    const url = `auctions/${auctionUrl}/hubs/`
    return this.get<OldWidgetsEntity[]>(url)
  }

  getWidgetPages(auctionUrl: string) {
    const url = `auctions/${auctionUrl}/widget-pages/`
    return this.get<WidgetPagesEntity[]>(url)
  }

  syncWidgetPage(auctionUrl: string, uuid: string) {
    const url = `auctions/${auctionUrl}/widget-pages/${uuid}/`
    return this.get<WidgetPagesEntity>(url)
  }

  addWidgetPage(auctionUrl: string, widgetPage: Partial<WidgetPagesEntity>) {
    const url = `auctions/${auctionUrl}/widget-pages/`
    return this.post<WidgetPagesEntity>(url, widgetPage)
  }

  updateWidgetPage(auctionUrl: string, widgetPage: Partial<WidgetPagesEntity>) {
    const url = `auctions/${auctionUrl}/widget-pages/${widgetPage.uuid}/`
    return this.patch<WidgetPagesEntity>(url, widgetPage)
  }

  deleteWidgetPage(auctionUrl: string, uuid: string) {
    const url = `auctions/${auctionUrl}/widget-pages/${uuid}/`
    return this.delete<void>(url)
  }
}
